export function openPresenterModeInNewWindow(presenterModeUrl: string) {
  const base = window.location.origin;
  const windowFeatures =
    'width=800, height=600, resizable=yes, scrollbars=yes, toolbar=no, menubar=no, history=no navigator=no name="PresenterMode"';
  window.open(`${base}${presenterModeUrl}`, '_blank', windowFeatures);
}

export const ASIDE_CONTENT_WIDTH = 349;
export const NEXT_PIN_VIEW_HEIGHT = 197;
